import { useState } from "react"
import ErrorMessage from "../../../components/ErrorMessage"
import EyeIcon from "../../../assets/images/icons/eye.svg"
import EyeSlashIcon from "../../../assets/images/icons/eye-slash.svg"

import { useTheme } from "../../../contexts/ThemeContext"
import getThemeColors from "../../../utils/getColorTheme"

const Register = ({
  handleRegister = () => {},
  isSingup,
  setIsSingup,
  inputEmailProps = {},
  inputPasswordProps = {},
  inputNameProps = {},
  errors = [],
}) => {
  const [showPassword, setShowPassword] = useState(false)
  const [showConfirmPassword, setShowConfirmPassword] = useState(false)
  const [acceptedTerms, setAcceptedTerms] = useState(false)
  const [subscribedNewsletter, setSubscribedNewsletter] = useState(false)
  const [confirmPassword, setConfirmPassword] = useState("")
  const [surname, setSurname] = useState("")
  const { addTheme } = useTheme()
  const { theme, background } = getThemeColors(addTheme)



  const nameValue = inputNameProps.defaultValue?.trim() || ""
  const emailValue = inputEmailProps.defaultValue?.trim() || ""
  const passwordValue = inputPasswordProps.defaultValue || ""

  const doPasswordsMatch = passwordValue === confirmPassword

  const isErrorEmail = errors.find(error => error.field === "email")
  const isErrorPassword = errors.find(error => error.field === "password")
  const isErrorName = errors.find(error => error.field === "name")

  const isFormValid =
    acceptedTerms &&
    nameValue !== "" &&
    emailValue !== "" &&
    passwordValue.trim() !== "" &&
    doPasswordsMatch

  const handleSubmit = (e) => {
    e.preventDefault()
    if (isFormValid) {
      const trimmedSurname = surname.trim()
      const fullname = trimmedSurname ? `${nameValue} ${trimmedSurname}` : nameValue

      handleRegister({
        name: nameValue,
        surname: trimmedSurname,
        fullname: fullname,
        email: emailValue,
        password: passwordValue,
        terms: acceptedTerms,
        newsletter: subscribedNewsletter,
      })
    }
  }

  return (
    <div className="auth-form">
      <form className="form-login" onSubmit={handleSubmit}>
        <div className="input-group">
          <div className="group">
            <label htmlFor="email" style={{ color: theme }}>Email *</label>
            <input
              type="text"
              className={`form-control ${isErrorEmail ? "error" : ""}`}
              placeholder="Enter your Email"
              name="email"
              id="email"
              style={{ background: "transparent", color: theme }}
              {...inputEmailProps}
            />
            {isErrorEmail && <ErrorMessage message={isErrorEmail.message} />}
          </div>

          <div className="group">
            <label htmlFor="password" style={{ color: theme }}>Password *</label>
            <div className="input-password-wrapper" style={{ position: "relative", width: "100%" }}>
              <input
                type={showPassword ? "text" : "password"}
                className={`form-control ${isErrorPassword ? "error" : ""}`}
                placeholder="Enter your Password"
                name="password"
                id="password"
                {...inputPasswordProps}
                style={{ paddingRight: "40px", width: "100%", boxSizing: "border-box", background: "transparent", color: theme }}
              />
              <span
                onClick={() => setShowPassword(!showPassword)}
                style={{
                  position: "absolute",
                  right: "10px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  cursor: "pointer",
                }}
              >
                <img
                  src={showPassword ? EyeSlashIcon : EyeIcon}
                  alt={showPassword ? "Hide password" : "Show password"}
                  style={{ filter: addTheme === "dark" ? "brightness(0) invert(1)" : "none" }}
                />
              </span>
            </div>
            {isErrorPassword && <ErrorMessage message={isErrorPassword.message} />}
          </div>

          <div className="group">
            <label htmlFor="confirmPassword" style={{ color: theme }}>Confirm Password *</label>
            <div className="input-password-wrapper" style={{ position: "relative", width: "100%" }}>
              <input
                type={showConfirmPassword ? "text" : "password"}
                className={`form-control ${!doPasswordsMatch ? "error" : ""}`}
                placeholder="Confirm your Password"
                name="confirmPassword"
                id="confirmPassword"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                style={{ paddingRight: "40px", width: "100%", boxSizing: "border-box", background: "transparent", color: theme }}
              />
              <span
                onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                style={{
                  position: "absolute",
                  right: "10px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  cursor: "pointer",
                }}
              >
                <img
                  src={showConfirmPassword ? EyeSlashIcon : EyeIcon}
                  alt={showConfirmPassword ? "Hide password" : "Show password"}
                  style={{ filter: addTheme === "dark" ? "brightness(0) invert(1)" : "none" }}
                />
              </span>
            </div>
            {!doPasswordsMatch && confirmPassword && (
              <ErrorMessage message="Passwords do not match" />
            )}
          </div>

          <div className="group">
            <label htmlFor="name" style={{ color: theme }}>First Name *</label>
            <input
              type="text"
              className={`form-control ${isErrorName ? "error" : ""}`}
              placeholder="Enter your First Name"
              name="name"
              id="name"
              style={{ background: "transparent", color: theme }}
              {...inputNameProps}
            />
            {isErrorName && <ErrorMessage message={isErrorName.message} />}
          </div>

          <div className="group">
            <label htmlFor="surname" style={{ color: theme }}>Last Name</label>
            <input
              type="text"
              className="form-control"
              placeholder="Enter your Last Name (optional)"
              name="surname"
              id="surname"
              value={surname}
              onChange={(e) => setSurname(e.target.value)}
              style={{ background: "transparent", color: theme }}
            />
          </div>
        </div>

        <div className="checkbox-wrapper">
          <label className="checkbox">
            <input
              type="checkbox"
              checked={acceptedTerms}
              onChange={(e) => setAcceptedTerms(e.target.checked)}
            />
            <span className="checkmark"></span>
            <span style={{ color: theme }}>I agree to the FAM platform<span style={{textDecoration: "underline" }}><a href="/terms" target="_blank" rel="noopener noreferrer" style={{ color: theme }}>Terms & Conditions</a></span>*</span>
          </label>

          <label className="checkbox">
            <input
              type="checkbox"
              checked={subscribedNewsletter}
              onChange={(e) => setSubscribedNewsletter(e.target.checked)}
            />
            <span className="checkmark"></span>
            <span style={{ color: theme }}>Subscribe me to your monthly newsletter</span>
          </label>
        </div>

        <button 
          type="submit" 
          className="btn-main" 
          disabled={!isFormValid}
          aria-label="Sign up for an account"
        >
          Sign up
        </button>

        <div className="forgot-password-link" style={{ marginBottom: "100px" }}>
          <button 
            type="button" 
            onClick={() => setIsSingup(!isSingup)}
            aria-label="Go to forgotten password page"
            style={{ color: theme }}
          >
            Forgotten password?
          </button>
        </div>
      </form>
    </div>
  )
}

export default Register
